import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const DocumentsCounter = ({ className = "" }) => {
  const [documentCount, setDocumentCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useAuth();

  const fetchDocumentCount = async () => {
    if (!user?.id) return;
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/${user.id}/documents`);
      const data = await response.json();
      
      if (data.success) {
        setDocumentCount(data.total || 0);
      }
    } catch (error) {
      console.error('Error fetching document count:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentCount();
  }, [user?.id]);

  // Listen for document upload events
  useEffect(() => {
    const handleDocumentUploaded = () => {
      fetchDocumentCount();
    };

    window.addEventListener('documentUploaded', handleDocumentUploaded);
    return () => window.removeEventListener('documentUploaded', handleDocumentUploaded);
  }, []);

  const handleClick = () => {
    navigate('/dashboard?tab=documents');
  };

  return (
    <div 
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-all duration-200 hover:bg-gray-50 ${className}`}
      onClick={handleClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">Documents Processed</h3>
          <div className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-blue-600" />
            <span className="text-2xl font-bold text-gray-900">
              {loading ? '--' : documentCount.toString().padStart(2, '0')}
            </span>
          </div>
        </div>
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
          <FileText className="w-6 h-6 text-blue-600" />
        </div>
      </div>
      <p className="text-sm text-gray-600 mt-2">Click to view all documents</p>
    </div>
  );
};

export default DocumentsCounter;